import e from './e.json';

export const appName = '納付券販売管理システム';

export const appz = e.appz;

export const cz = {
  itemz: {
    key: 1,
    //text: '大型ごみ等処理手数料納付券',
    text: '大型ごみ納付券',
    unit: '冊',
    prc: 5000, // sales price
    blg: 4450, // billing amount
    csn: 550, // comission
  },
  clr: 'rd',
}

export const abtz = {
  btnAddz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 10,
    icn: 'plus',
    ics: 2,
    icc: 'lt1',
//    sc: 'lt5',
    sc: `${cz.clr}5`,
    text: '追加',
    ts: 's',
  },
  btnBackz: {
    type: 'ctd',
    br: 1,
    dh: 4,
    dw: 30,
    tc: 'lt5',
    ts: 'm',
    sc: 'lt3',
  },
  btnCfmz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 10,
    sc: `${cz.clr}5`,
    text: '確認・変更',
    ts: 's',
  },
  btnDltz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 10,
    icn: 'trash',
    ics: 2,
    icc: 'lt1',
//    sc: 'lt5',
    sc: `${cz.clr}5`,
    text: '削除',
    ts: 's',
  },
  btnDtlz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 10,
    sc: `${cz.clr}5`,
    text: '確認・変更',
    ts: 's',
  },
  btnHome1z: {
    type: 'ctd',
    br: 1,
    dh: 15,
    dw: 30,
    tc: 'lt1',
    ts: 'l',
    sc: `${cz.clr}6`,
  },
  btnHome2z: {
    type: 'ctd',
    br: 1,
    dh: 15,
    dw: 30,
    tc: 'lt1',
    ts: 'l',
    sc: `${cz.clr}4`,
  },
  btnIconz: {
    type: 'icon',
    tc: `${cz.clr}6`,
    ts: 'xxs',
    icc: `${cz.clr}6`,
    ics: 4,
  },
  btnNextz: {
    type: 'ctd',
    br: 1,
    dh: 4,
//    dw: 28,
    dw: 24,
    tc: 'lt1',
    ts: 'm',
    sc: `${cz.clr}6`,
  },
  btnNext2z: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 15,
    tc: 'lt1',
    ts: 'm',
    sc: `${cz.clr}4`,
  },
  btnSchz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 10,
    tc: 'lt1',
    text: '検索',
    ts: 's',
    sc: `${cz.clr}4`,
  },
  gridBtnz: {
    type: 'nml',
    br: 0,
    dh: 'n',
    f: 'n',
    fd: 'rac',
    fw: 'n',
    mb: 1,
    p: 0,
    sc: 't',
  },
  gridTblHdrz: {
    type: 'nml',
    br: 0,
    dh: 'n',
    f: 1,
    fd: 'rsc',
    fw: 'n',
//    mb: 1,
    mb: 0.5,
    p: 0,
    sc: 't',
  },
  gridTblBdyz: {
    type: 'nml',
    br: 0,
    dh: 'n',
    f: 1,
    fd: 'rsc',
    fw: 'n',
//    mb: 1,
    mb: 0.5,
    p: 0,
    sc: 't',
  },
  gridCttz: {
    type: 'nml',
    br: 0,
    dh: 'n',
    f: 1,
    fd: 'rss',
    fw: 'n',
    mb: 1,
    p: 0,
    sc: 't',
  },
  gridHomez: {
    type: 'nml',
    br: 0,
    dh: 'f',
    f: 1,
    fd: 'rac',
    fw: 'n',
    mb: 0,
    p: 0,
    sc: 't',
  },
  gridSchz: {
    type: 'nml',
    br: 1,
    dh: 'n',
    f: 'n',
    fd: 'rac',
    fw: 'n',
    mb: 0,
    p: 1,
    sc: `${cz.clr}2`,
  },
  lblHzlz: {
    type: 'hzl',
    dw: 15,
    tc: `${cz.clr}7`,
    ts: 'm',
  },
  lblVclz: {
    type: 'vcl',
    tc: `${cz.clr}7`,
  },
  mainHdrz: {
    type: 'nml',
    sc: `${cz.clr}4`,
  },
  tblLinez: {
    type: 'line',
    bc: `${cz.clr}7`,
  },
  textLblz: {
    type: 'lbl',
    tc: `${cz.clr}7`,
    tn: 1,
    ts: 'm',
  },
  textTtlz: {
    type: 'lbl',
    tc: `${cz.clr}7`,
    ts: 'xl',
    tn: 1,
  },
  textVlez: {
    type: 'nml',
    tn: 1,
    ts: 'm',
  }
};

export const dsnz = {
  dwrW: 0,
  pageHdrH: 7,
  mainHdrH: 4,
  mainFtnH: 6,
}

export const lz = {
  _10rt1100i: [
    { key: 10, text: '一般' },
  ],
/*
  i11rt1100i: [ // 店種
    { key: -1, text: ' ' },
    { key: 10, text: '一般商店' },
    { key: 20, text: 'スーパー' },
    { key: 30, text: 'コンビニ' },
  ],
*/
  i11rs1100i: [
//    { key: -1, text: ' ' },
//    { key: 10, text: '未契約' },
    { key: 20, text: '契約中' },
    { key: 90, text: '契約終了' },
  ],
  iz1rs1100i: [ // 対応状況
    { key: -1, text: ' ' },
//    { key: 10, text: '未受注' },
    { key: 20, text: '受注済' },
    { key: 30, text: '配付済' },
    //{ key: 40, text: '売上済' },
    //{ key: 50, text: '請求済' },
    { key: 60, text: '入金済' },
  ],
  iz1ra1100i: [ // 依頼冊数 // 未使用
    { key: -1, text: ' ' },
    { key: 10, text: ' 10冊' },
    { key: 20, text: ' 20冊' },
    { key: 30, text: ' 30冊' },
    { key: 40, text: ' 40冊' },
    { key: 50, text: ' 50冊' },
    { key: 60, text: ' 60冊' },
    { key: 70, text: ' 70冊' },
    { key: 80, text: ' 80冊' },
    { key: 90, text: ' 90冊' },
    { key: 100, text: '100冊' },
  ],
};
